import Axios, { AxiosObservable } from "axios-observable";
import { IResponse } from "interfaces";

const DATA_STUDIO = "/data-studio/run-query";
const DATA_STUDIO_TABLE_DEFINITIONS = "/data-studio/get-definitions";
const GET_LIST_ENTITIES = "/data-studio/list-entities";
const GET_STUDIO_VIEWS = "/data-studio/list-views"
const SAVE_STUDIO_VIEW = "/data-studio/save-view"

export const queryResults = (result: any): AxiosObservable<IResponse<any>> => {
  return Axios.post<IResponse<any>>(
    DATA_STUDIO, // The URL for the POST request
    {
      query: {
        columns: result,
      },
    }
  );
};

export const tableDefinitionsQuery = (): AxiosObservable<IResponse<any>> => {
  return Axios.post<IResponse<any>>(DATA_STUDIO_TABLE_DEFINITIONS);
};

export const getListEntities = (
  type: string
): AxiosObservable<IResponse<any>> => {
  return Axios.post<IResponse<any>>(GET_LIST_ENTITIES, { type });
};

export const getStudioViews = (): AxiosObservable<IResponse<any>> => {
  return Axios.post<IResponse<any>>(GET_STUDIO_VIEWS);
};


export const saveStudioViews = (id: string, title: string, view: any): AxiosObservable<IResponse<any>> => {
  return Axios.post<IResponse<any>>(SAVE_STUDIO_VIEW, {
    viewId: id,
    title,
    view
  });
};
